import Vue from 'vue';
import { post,get } from '../request/request';
import { uploadOSS } from "@/util/oss";


Vue.prototype.$uploadOSS = uploadOSS;

Vue.prototype.$post = post;
Vue.prototype.$get = get;
